import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { apiUrl, s3initialurl, s3PresignedUrlGen } from "../config/apiUrl";
import Loading from "../../lib/steps_components/common/Loading";
import { getSessionId } from "../utils/sessionmanagement";
import uploadIcon from '../assets/upload_icon.svg';

class UploadFileV2Component extends Component {
    constructor(props) {
        super(props);
        this.uploadV2Ref = createRef();
        this.state = {
            filepath: null,
            isLoading: true,
            uploadClicked: false,
        };
    }

    componentDidMount() {
        window.addEventListener('rapid-web-view-upload-listener', this.getUploadStatus);
    }

    componentWillUnmount() {
        window.removeEventListener('rapid-web-view-upload-listener')
    }

    getUploadStatus = (e) => {
        const uploadStatus = e.detail.status
        this.setState({ isLoading: false });
        if (uploadStatus === 'success') {
            let urlFileInfo = `${apiUrl}candidate-response/`;

            const name = this.props.name;
            const chatFormIdentifier = this.props.chatFormIdentifier;
            const type = this.props.type;
            let identifier = this.props.identifier;
            let identifierType = this.props.identifierType;
            let sessionId = getSessionId();

            let body = {
                chat_identifier: chatFormIdentifier,
                session_id: sessionId,
                identifier: identifier,
                identifier_type: identifierType,
                type: type,
                response: {
                    [name]: s3initialurl + this.state.filepath,
                },
            };

            fetch(urlFileInfo, {
                method: "post",
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((dataReceived) => {
                    this.setState({ isLoading: false });
                    this.props.triggerNextStep();
                });
        } else {
            alert("Something went wrong! Please retry after sometime.");
        }
    }

    handleUpload = () => {
        if (!this.state.uploadClicked) {
            this.setState({ uploadClicked: true });
            let sessionId = getSessionId();

            let url = s3PresignedUrlGen;
            let body = {
                origin: "chat_bot",
                filename: `${this.props.identifier}_${sessionId}`,
            };

            fetch(url, {
                method: "post",
                body: JSON.stringify(body),
            })
                .then((res) => res.json())
                .then((dataReceived) => {
                    let urlFilePost = dataReceived.signedUrl;
                    this.setState({ filepath: dataReceived.key })
                    window.app.uploadFile('image', urlFilePost, 'PUT');
                });
        } else {
        }
    };

    render() {
        return (
            <div ref={this.uploadV2Ref}>
                <div>
                    <div
                        style={{
                            background: "#FFFFFF",
                            borderRadius: "6px",
                            padding: "5px 16px",
                            color: "#33418a",
                            borderWidth: "1px",
                            boxShadow:
                                "0px 2px 11px rgb(0 0 0 / 30%), 0px 2px 6px rgb(0 0 0 / 15%",
                            margin: "5px auto",
                            fontWeight: "600",
                        }}
                        onClick={this.handleUpload}
                    >
                        Upload File
                        <img src={uploadIcon} alt="upload" width={14} height={14}/>
                    </div>
                </div>
                {this.state.isLoading && this.state.uploadClicked ? <Loading /> : null}
            </div>
        );
    }
}

UploadFileV2Component.propTypes = {
    steps: PropTypes.object,
};

UploadFileV2Component.defaultProps = {
    steps: undefined,
};

export default UploadFileV2Component;
